import { render, staticRenderFns } from "./MusculoskeletalSymptomsSurveyTable.vue?vue&type=template&id=09cb084c&scoped=true"
import script from "./MusculoskeletalSymptomsSurveyTable.vue?vue&type=script&lang=js"
export * from "./MusculoskeletalSymptomsSurveyTable.vue?vue&type=script&lang=js"
import style0 from "./MusculoskeletalSymptomsSurveyTable.vue?vue&type=style&index=0&id=09cb084c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cb084c",
  null
  
)

export default component.exports